module["exports"] = [
  "Dr.",
  "Prof.",
  "PhD."
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/sv/name/prefix.js
// module id = 1264
// module chunks = 0